import { render, staticRenderFns } from "./addDyHomeUrl.vue?vue&type=template&id=5120a55a"
import script from "./addDyHomeUrl.vue?vue&type=script&lang=js"
export * from "./addDyHomeUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports